"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    TabListContext: ()=>TabListContext,
    TabListProvider: ()=>TabListProvider,
    useTabListContext_unstable: ()=>useTabListContext_unstable
});
const _reactContextSelector = require("@fluentui/react-context-selector");
const tabListContextDefaultValue = {
    appearance: 'transparent',
    reserveSelectedTabSpace: true,
    disabled: false,
    selectedValue: undefined,
    onRegister: ()=>{
    /* noop */ },
    onUnregister: ()=>{
    /* noop */ },
    onSelect: ()=>{
    /* noop */ },
    getRegisteredTabs: ()=>{
        return {
            registeredTabs: {}
        };
    },
    size: 'medium',
    vertical: false
};
const TabListContext = /*#__PURE__*/ (0, _reactContextSelector.createContext)(undefined);
const TabListProvider = TabListContext.Provider;
const useTabListContext_unstable = (selector)=>(0, _reactContextSelector.useContextSelector)(TabListContext, (ctx = tabListContextDefaultValue)=>selector(ctx)); //# sourceMappingURL=TabListContext.js.map

//# sourceMappingURL=TabListContext.js.map